import type { SubscriptionStatus } from "@shared/api";

const STATUS_MAP: Record<
  SubscriptionStatus,
  { label: string; cls: string }
> = {
  active: { label: "Active", cls: "ok" },
  "renewal-due": { label: "Renewal due", cls: "warn" },
  trial: { label: "Trial", cls: "info" },
  paused: { label: "Paused", cls: "muted" },
  expired: { label: "Expired", cls: "danger" },
  pending: { label: "Pending", cls: "info" },
};

interface Props {
  status: SubscriptionStatus;
}

export function StatusBadge({ status }: Props) {
  const meta = STATUS_MAP[status] ?? { label: status, cls: "muted" };
  return (
    <span className={`bbc-status bbc-status-${meta.cls}`}>
      <i />
      {meta.label}
    </span>
  );
}
